import { CURRENT_ENV } from '@root/core/configs/env';

enum APP_ROLE {
  sellerAdmin = 'seller-admin',
  warehouseAdmin = 'warehouse-admin'
}

interface ICommentMessage {
  edit: string;
  adjust: string;
  send: string;
  delete: string;
  confirmDisposal: string;
  disposalApproved: string;
  confirmReturn: string;
  returnApproved: string;
  inventoryApproved: string;
  requesting: string;

  // for modify
  modifyApproval: string;
  modifyRejected: string;
  rejectedModify: string;
  rejectModify: string;
  modified: string;

  // for delete
  deleteApproval: string;
  deleteRejected: string;
  rejectedDelete: string;
  rejectDelete: string;
  requestDelete: string;
}

interface IMessage {
  [APP_ROLE.sellerAdmin]: ICommentMessage;
  [APP_ROLE.warehouseAdmin]: ICommentMessage;
}

export class CommentLang {
  private appRole: APP_ROLE;
  private static instance?: CommentLang;

  private constructor(appRole: APP_ROLE) {
    this.appRole = appRole;
  }

  public static get = (key: keyof ICommentMessage) => {
    if (this.instance === undefined) {
      this.instance = new CommentLang(CURRENT_ENV.APP_ROLE as APP_ROLE);
    }

    return this.instance.message[this.instance.appRole][key];
  };

  private message: IMessage = {
    [APP_ROLE.sellerAdmin]: {
      adjust: '수정',
      edit: '수정 하기',
      send: '전송',
      delete: '삭제 하기',
      confirmDisposal: '폐기요청 확인',
      disposalApproved: '폐기요청 승인',
      confirmReturn: '반품요청 확인',
      returnApproved: '반환요청 승인',
      inventoryApproved: '제고전환 승인',
      requesting: '요청 중',
      modifyApproval: '수정승인',
      modifyRejected: '수정요청 거절됨',
      rejectModify: '수정거절',
      modified: '수정완료',
      rejectedModify: '수정요청 거절함',
      deleteApproval: '삭제승인',
      deleteRejected: '삭제요청 거절됨',
      rejectedDelete: '삭제요청 거절함',
      requestDelete: '삭제요청',
      rejectDelete: '삭제거절',
    },
    [APP_ROLE.warehouseAdmin]: {
      adjust: 'Edit',
      edit: 'Edit',
      send: 'Send',
      delete: 'To delete',
      confirmDisposal: 'Confirmation of disposal request',
      disposalApproved: 'Disposal request approval',
      confirmReturn: 'Confirmation of return request',
      returnApproved: 'Return request approval',
      inventoryApproved: 'Inventory conversion approval',
      requesting: 'Requesting',
      modifyApproval: 'Modification approval',
      modifyRejected: 'Refusal of modification request',
      rejectModify: 'Modification refusal',
      modified: 'Modification completed',
      rejectedModify: 'Refusal of modification request',
      deleteApproval: 'Deletion approval',
      deleteRejected: 'Refusal of deletion request',
      rejectedDelete: 'Refusal of deletion request',
      requestDelete: 'Request delete',
      rejectDelete: 'Deletion refusal',
    }
  };
}
